/** Plain-text job card summary for pasting into WhatsApp (*bold* is WhatsApp markup). */
export type JobCardShareInput = {
  title: string;
  customerName?: string | null;
  siteAddress?: string | null;
  /** Left out when the viewer cannot see the customer's phone. */
  phone?: string | null;
  /** "Installation" or "Delivery". */
  dateLabel: string;
  dates?: string | null;
  sensitiveCustomer?: boolean;
  surveyorNotes?: string | null;
  spec?: string | null;
  crew?: string[];
};

export function mapsLink(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

export function jobCardShareText(input: JobCardShareInput): string {
  const lines: string[] = [`*${input.title.trim() || 'Job card'}*`];
  const add = (label: string, value?: string | null) => {
    const text = String(value || '').trim();
    if (text) lines.push(`*${label}:* ${text}`);
  };
  add('Customer', input.customerName);
  const address = String(input.siteAddress || '').trim();
  if (address) {
    add('Address', address);
    lines.push(mapsLink(address));
  }
  add('Phone', input.phone);
  add(input.dateLabel, input.dates);
  if (input.sensitiveCustomer) lines.push('*Sensitive customer:* Yes');
  add('Spec', input.spec);
  const crew = (input.crew || []).map((name) => name.trim()).filter(Boolean);
  if (crew.length) add('Crew', crew.join(', '));
  const notes = String(input.surveyorNotes || '').trim();
  if (notes) lines.push('', '*Surveyor notes:*', notes);
  return lines.join('\n');
}
